__turbopack_context__.v({
  "chip": "SocialIconLink-module__eDkemG__chip",
  "icon": "SocialIconLink-module__eDkemG__icon",
  "lg": "SocialIconLink-module__eDkemG__lg",
  "md": "SocialIconLink-module__eDkemG__md",
  "root": "SocialIconLink-module__eDkemG__root",
  "sm": "SocialIconLink-module__eDkemG__sm",
});
